import { withSvgIcon } from './withSvgIcon';

export const NavBarEndpoints = withSvgIcon(
  <path
    d="M12 11L19.8375 7.1302M12 11V20.5M12 11L4.15234 7.125M12.8944 3.44721L18.8944 6.44721C19.4323 6.71617 19.7013 6.85065 19.8507 7.0923C20 7.33395 20 7.63466 20 8.23607V15.7639C20 16.3653 20 16.666 19.8507 16.9077C19.7013 17.1493 19.4323 17.2838 18.8944 17.5528L12.8944 20.5528C12.4555 20.7722 12.2361 20.882 12 20.882C11.7639 20.882 11.5445 20.7722 11.1056 20.5528L5.10557 17.5528C4.56766 17.2838 4.2987 17.1493 4.14935 16.9077C4 16.666 4 16.3653 4 15.7639V9.47213C4 8.26932 4 7.66791 4.2987 7.1846C4.5974 6.7013 5.13531 6.43234 6.21115 5.89442L11.1056 3.44721C11.5445 3.22776 11.7639 3.11803 12 3.11803C12.2361 3.11803 12.4555 3.22776 12.8944 3.44721Z"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  { viewBox: '0 0 24 24' },
);
